import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Footprints, Clock, Smile, Radar, HandMetal } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <Footprints className="w-6 h-6 text-accent" data-id="element-34" />,
    text: 'El sistema de lectura de pies para saber quién quiere irse de la habitación antes de que se mueva.'
  }, {
    icon: <Clock className="w-6 h-6 text-accent" data-id="element-35" />,
    text: 'La técnica de los "2 segundos extra" para proyectar una autoridad inquebrantable.'
  }, {
    icon: <Smile className="w-6 h-6 text-accent" data-id="element-36" />,
    text: 'El mapa de las 7 microexpresiones universales para detectar desprecio o miedo en milisegundos.'
  }, {
    icon: <Radar className="w-6 h-6 text-accent" data-id="element-37" />,
    text: 'El radar de "racimos de engaño" para identificar mentiras sin necesidad de un polígrafo.'
  }, {
    icon: <HandMetal className="w-6 h-6 text-accent" data-id="element-38" />,
    text: 'Guía práctica de gestos de poder para dominar cualquier mesa de negociación.'
  }];
  return <section className="py-24 bg-surface relative overflow-hidden" data-id="element-39">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-40"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-41">
        <div className="text-center mb-16" data-id="element-42">
          <FadeIn data-id="element-43">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-44">
              Qué obtendrás con este manual:
            </h2>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-45">
            <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-46">
              Herramientas prácticas y aplicables desde el primer día para leer
              a las personas como un libro abierto.
            </p>
          </FadeIn>
        </div>

        <div className="grid gap-6" data-id="element-47">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={0.2 + index * 0.1} direction="left" data-id="element-48">
              <div className="flex items-start gap-6 p-6 sm:p-8 rounded-2xl bg-background border border-white/5 hover:border-accent/30 transition-colors group" data-id="element-49">
                <div className="w-12 h-12 rounded-full bg-surfaceHighlight flex items-center justify-center shrink-0 border border-white/10 group-hover:scale-110 transition-transform duration-300" data-id="element-50">
                  {benefit.icon}
                </div>
                <p className="text-lg sm:text-xl text-slate-300 font-medium leading-relaxed pt-2" data-id="element-51">
                  {benefit.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}